import { motion } from 'framer-motion'
import { Mail, Phone, MapPin } from 'lucide-react'
import { Section, SectionHeading } from '../ui/Section'
import Reveal, { RevealGroup, RevealItem } from '../ui/Reveal'
import ContactForm from './ContactForm'
import { COMPANY } from '../../data/company'

export default function Contact() {
  const methods = [
    { icon: Mail, label: 'email', value: COMPANY.contact.email, href: `mailto:${COMPANY.contact.email}` },
    { icon: Phone, label: 'phone', value: COMPANY.contact.phone, href: `tel:${COMPANY.contact.phone}` },
    { icon: MapPin, label: 'location', value: COMPANY.contact.location },
  ]

  return (
    <Section id="contact" atmosphere="right">
      <div className="grid gap-14 lg:grid-cols-2 lg:gap-16 2xl:gap-24">
        <div>
          <SectionHeading
            eyebrow="Contact"
            title="Discuss a project or request a quotation"
            lead="Share your requirements and timeline. A member of our team will respond within one business day, and we can follow up with a formal quotation."
          />
          <RevealGroup each={0.06} delay={0.1} className="rule-draw mt-12">
            {methods.map((m) => {
              const Wrapper = m.href ? motion.a : motion.div
              return (
                <RevealItem key={m.label}>
                  <Wrapper
                    {...(m.href ? { href: m.href } : {})}
                    className="group flex items-center gap-5 border-b border-outline-variant py-5"
                  >
                    <span className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-primary-container text-primary-on-container shadow-[inset_0_1px_0_rgb(var(--highlight))]">
                      <m.icon className="h-[18px] w-[18px]" strokeWidth={1.75} />
                    </span>
                    <div>
                      <p className="font-mono text-[11px] font-bold uppercase tracking-wider text-ink-3">{m.label}</p>
                      <p className="mt-0.5 font-mono text-base font-semibold text-ink">{m.value}</p>
                    </div>
                  </Wrapper>
                </RevealItem>
              )
            })}
          </RevealGroup>
        </div>

        <div>
          <Reveal delay={0.1} className="surface rounded-[2rem] p-6 !shadow-[inset_0_1px_0_rgb(var(--highlight)),var(--elev-4)] md:p-9">
            <p className="eyebrow">Project enquiry</p>
            <ContactForm className="mt-6" />
          </Reveal>
        </div>
      </div>
    </Section>
  )
}
